






























import {Component, Vue} from 'vue-property-decorator'
import Api from '@/services/Api'

@Component({})
export default class Home extends Vue {


    login(event: Event) {
        event.preventDefault()
    }

}
